export enum ViewFromProperty {
    Clear = 'Clear',
    Blocked = 'Blocked',
    Outstanding = 'Outstanding',
}
